module.exports = __webpack_public_path__ + "static/media/logo.9a22d114.svg";